var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 63,
    viewBox: "0 0 102 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.8255 59.1508L93.414 37.9812L52.5459 48.5527L61.9282 58.8669C62.6779 59.6912 63.93 59.8138 64.8255 59.1508Z",
    fill: "#E3BB41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94342 39.6318C4.17605 38.3916 4.8256 36.7627 6.23575 36.3908L81.7276 16.4845C82.6596 16.2388 83.642 16.6371 84.1398 17.4624L94.5913 34.7936C95.3413 36.0372 94.6821 37.6522 93.2762 38.0159L17.8174 57.5351C16.8969 57.7732 15.9284 57.3844 15.4281 56.5758L4.94342 39.6318Z",
    fill: "#F2C94C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9677 15.9428L5.44879 36.8753L46.095 26.0809L36.8352 16.2077C36.084 15.4068 34.853 15.293 33.9677 15.9428Z",
    fill: "#E3BB41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.4f0afa34.svg";
export { ForwardRef as ReactComponent };